/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaCittadinoOtpContextDTO { 
    canale?: PraticaCittadinoOtpContextDTOCanaleEnum;
    destinatario_mascherato?: string;
    scadenza_codice_at?: string;
    reinvio_disponibile_at?: string;
    tentativo_numero?: number;
    tentativi_rimanenti?: number;
}
export enum PraticaCittadinoOtpContextDTOCanaleEnum {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    WA = 'WA'
};



